module.exports = __webpack_public_path__ + "media/images/samples/infographics/info-1@2x-bf706380ceb70838bcfa2d1b655dbbc0.jpg";